import request from '../util/request'
export function getEvaluationFormList(params) {
  return request({
    url: 'pr/evaluation-forms',
    method: 'get',
    params
  })
}

/**
 * 创建评价表
 * @param {*} data 
 * @returns 
 */
export function createEvaluationForm(data) {
  return request({
    url: 'pr/evaluation-forms',
    method: 'post',
    data
  })
}
/**
 * 修改评价表
 * @param {*} params 
 * @returns 
 */
export function editEvaluationForm(params) {
  return request({
    url: 'pr/evaluation-forms/' + params.id,
    method: 'put',
    params
  })
}